import { render, staticRenderFns } from "./07-Capture_face.vue?vue&type=template&id=dab9f642&scoped=true&"
import script from "./07-Capture_face.vue?vue&type=script&lang=js&"
export * from "./07-Capture_face.vue?vue&type=script&lang=js&"
import style0 from "./07-Capture_face.vue?vue&type=style&index=0&id=dab9f642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab9f642",
  null
  
)

export default component.exports